import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import ArrowLeft from "../../assets/img/arrow-to-left.svg";

const useStyles = makeStyles({
  backButtonLink: {
    width: "7%",
    display: "block",
    textDecoration: "none",
    color: "#636363",
    fontSize: 13,
    "&:active": {
      color: "initial",
    },
  },
  backButton: {
    marginTop: "-4px",
    display: "flex",
    color: "rgb(113, 114, 117)",
    fontSize: 16,
  },
  arrowLeft: {
    width: 8,
    marginRight: 5,
    paddingTop: 3,
  },
});

export default function ButtonBack(props) {
  const classes = useStyles();

  return (
    <Link to={props.link} className={classes.backButtonLink}>
      <Button className={classes.backButton}>
        <img src={ArrowLeft} className={classes.arrowLeft} alt="Botão voltar" />
        Voltar
      </Button>
    </Link>
  );
}
